module.exports = __webpack_public_path__ + "a832a502c58584ea288fd4bd03c2fbca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/tea-cups.png
// module id = 2890
// module chunks = 0